import * as form from '../form';

export const foreignBusinessEmployment = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Name: form.name(xitem.Name),
        Description: form.textarea(xitem.Description),
        Date: form.datecontrol(xitem.Date),
        Address: form.location(xitem.Address),
        Accepted: form.branch(xitem.Accepted),
        Explanation: form.textarea(xitem.Explanation),
        AcceptedDate: form.datecontrol(xitem.AcceptedDate), // PVQ Only
        PerformedService: form.branch(xitem.PerformedService), // PVQ Only
        DatesPerformed: form.daterange(xitem.DatesPerformed), // PVQ Only
        Compensation: form.text(xitem.Compensation), // PVQ Only
        HasOngoingObligations: form.branch(xitem.HasOngoingObligations), // PVQ Only
        OngoingObligationsExplanation: form.textarea(xitem.OngoingObligationsExplanation), // PVQ Only
      },
    };
  });
  return {
    HasForeignEmployment: form.branch(data.HasForeignEmployment),
    List: form.collection(items, (data.List || {}).branch),
  };
};
